export default __webpack_public_path__ + "assets/enterprise-three-three-small.ee06ccac701016113b5a55fbee6b6d41.png";